// extracted by mini-css-extract-plugin
export var notificationHost = "_mg-0";